"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ERROR_MESSAGES = void 0;
const FETCH_ERROR_MESSAGES = exports.FETCH_ERROR_MESSAGES = {
  FAILED_TO_FETCH: "Failed to fetch",
  NETWORK_ERROR: "NetworkError when attempting to fetch resource"
};